import MainWrapper from '@ulta/core/components/MainWrapper/MainWrapper';

export default MainWrapper;